export default __webpack_public_path__ + "797af719102f876c669fa0685ec3c626.png";